import { Button } from "@/components/ui/button";
import { Bell, BellOff, BellRing } from "lucide-react";
import { useReminderNotifications } from "@/hooks/useReminderNotifications";
import { toast } from "sonner";

export default function NotificationsToggle({ apiCall }) {
  const { supported, permission, enabled, requestPermission, disable } = useReminderNotifications(apiCall);

  if (!supported) {
    return null;
  }

  const handleClick = async () => {
    if (enabled) {
      disable();
      toast.success("Notificações desativadas");
      return;
    }
    if (permission === "denied") {
      toast.error(
        "Permissão bloqueada no navegador. Abra o cadeado/ícone ao lado do endereço → Permissões → Notificações → Permitir, e recarregue a página.",
        { duration: 8000 }
      );
      return;
    }
    const result = await requestPermission();
    if (result === "granted") {
      toast.success("Notificações ativadas! Você será avisado dos lembretes.");
      try {
        new Notification("Greg One", {
          body: "Notificações ativadas com sucesso.",
          icon: "/favicon.ico",
          tag: "greg-welcome",
        });
      } catch {}
    } else if (result === "denied") {
      toast.error("Permissão negada pelo navegador.");
    }
  };

  const label = enabled ? "Notificações ON" : permission === "denied" ? "Bloqueadas" : "Ativar avisos";
  const Icon = enabled ? BellRing : permission === "denied" ? BellOff : Bell;

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={handleClick}
      data-testid="notifications-toggle-btn"
      className="gap-2"
    >
      <Icon className="h-4 w-4" strokeWidth={1.5} />
      {label}
    </Button>
  );
}
